const LOCAL_URL = "http://localhost:8000"
const PROD_URL = "https://api.safelaunch.io"
const BASE_URL = process.env.NODE_ENV === "development" ? PROD_URL : PROD_URL
export const API_URL = `${BASE_URL}/admin`
export const LOGIN_URL = `${BASE_URL}/login/access-token`
export const GENERATE_LOGO_UPLOAD_URL = `${BASE_URL}/deal/generate-upload-url`

export const BSCSCAN_URL = "https://bscscan.com"
